import React, { Component } from 'react';
import { View, TouchableOpacity, ActivityIndicator } from 'react-native';

import Text from '../textComponent';

import styles from './styles';
import Colors from '../../config/Colors';

export default class ButtonLoading extends Component {
    render() {
        const {
            label,
            onPress,
            isLoading = false,
            disabled,
            textColor,
            children
        } = this.props;

        return (
            <TouchableOpacity
                style={[
                    styles.button,
                    this.props.style,
                    disabled ? styles.buttonDisabled : ''
                ]}
                onPress={onPress}
                disabled={isLoading || disabled}
                htmlFor={this.props.htmlFor}
            >
                {isLoading ? (
                    <ActivityIndicator color={Colors.white} />
                ) : (
                    <View style={styles.buttonBox}>
                        <Text style={[styles.buttonText, textColor]}>
                            {label}
                        </Text>
                        {children}
                    </View>
                )}
            </TouchableOpacity>
        );
    }
}
